import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Container, Row, Col } from "react-bootstrap";
import { Accordion } from 'react-bootstrap';
import "../layout/css/style.css";
import "../layout/css/WidgetBrands.css";
import Footer from "../layout/Footer.js";
import Lead_Form from "../widgets/forms/price/widget-action-form.js";
import ShortLeadForm from "../widgets/forms/price/short-lead-form.js";
import FAQ from "../widgets/WidgetFAQ.js";
import mentalhealth from "../assets/Images/Understanding-Hearing-Loss-and-Hearing-Aids.webp";
import BTE from "../assets/Images/bte.webp";
import CIC from "../assets/Images/cic_beige.webp";
import RechargeableHA from "../assets/Images/signia-rechargeable.webp";
import BluetootHA from "../assets/Images/Phonak-Audeo-Paradise.webp";
import Bookhearingtest from "../assets/Images/book-a-free-hearing-test.webp";
import maplocation from "../assets/Images/map-location.webp";
import LeadForm from "../widgets/forms/widget-action-form.js";
import { Helmet } from "react-helmet";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import signiaImg from "../assets/Images/privileged-partner-signia.webp";
import phonakImg from "../assets/Images/authorised-partner-phonak.webp";
import resoundImg from "../assets/Images/authorised-partner-resound.webp";

const InfoKarnal = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <title>Hearing aids at SFL come with pocket-friendly prices and lifetime addon benefits - SFL Hearing Solutions
        </title>
        <meta name="description"
          content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta name="robots" content="INDEX, FOLLOW" />
        <link rel="canonical" href="https://ads.soundforlife.in/hearing-aids-info-karnal" />
        <meta name="DC.title" content="Best hearing aid solution - Book a Hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="SFL Hearing Solutions" />
        <meta property="og:title" content="Best hearing aid solution - Book a Hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:description"
          content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta property="og:type" content="Website" />
        <meta property="og:image" content="https://ads.soundforlife.in/assets/images/og-image.jpg" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Best hearing aid solution - Book a Hearing aid trial now - SFL Hearing Solutions" />
        <meta property="og:url" content="https://ads.soundforlife.in/hearing-aids-info-karnal" />
        <link rel="preload" as="image" href={mentalhealth} />
      </Helmet>
      {/* Header Section */}
      <header className="bg-primary bg-opacity-50 py-5">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Banner Column */}
            <div className="col-lg-7 position-relative">
              <div className="position-relative">
                <img
                  src={mentalhealth} width="190" height="143" alt="hearing aids"

                  className="img-fluid w-100 rounded shadow lcp-img" fetchpriority="high"


                />
                <div className="banner-overlay position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white p-4">
                  <h1 className="h2 h1-md">Understanding Hearing Loss and
                    Hearing Aids</h1>
                  <p className="mb-0">
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-users me-1"></i> Trusted by Thousands
                    </span>
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-microchip me-1"></i> Advanced Technology
                    </span>
                    <span className="tag bg-success fw-bold">
                      <i className="fa-solid fa-indian-rupee-sign me-1"></i> Affordable Prices
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Form Column */}
            <div className="col-lg-5">

              <Lead_Form />
            </div>

          </div>
        </div>
      </header>

      {/* Main Content Section */}
      <div className="container py-5">
        {/* Bullet Points */}
        <div className="mb-4 text-center">
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Hearing Test
          </span>
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Latest Hearing Machine
            Options
          </span>
          <span className="d-block d-md-inline-block fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Expert Audiologists
          </span>
        </div>

        {/* Intro */}
        <section className="hearing-loss-section container py-3">
          <h2 className="fw-bold display-6 title"><span className="title-info">What Is Hearing Loss?</span></h2>
          <p className="fs-5">
            Hearing loss occurs when there is reduced sensitivity to sound in one or both ears. It may affect your ability to hear clearly, follow conversations, or enjoy daily life.
          </p>

          <div className="search-queries-box mt-4 p-3">
            <h5 className="fw-semibold mb-2">Common Search Queries:</h5>
            <p className="fst-italic text-dark mb-0">
              “ear machine for hearing”, “hearing loss machine”, “kan sunne wali machine price”, “hearing test centers near me”
            </p>
          </div>

          <div className="mt-3">
            <h4 className="fw-semibold mb-3">Common Signs of Hearing Loss</h4>
            <ul className="signs-list">
              <li>Asking people to repeat often</li>
              <li>Struggling to hear in noisy places</li>
              <li>Turning up the TV volume</li>
              <li>Mishearing words or names</li>
              <li>Avoiding phone calls or conversations</li>
            </ul>

          </div>

          <div className="mt-3">
            <h4 className="fw-semibold">Types of Hearing Loss We Treat</h4>
            <div className="table-responsive">
              <table className="table table-bordered table-striped mt-3">
                <thead className="table-primary">
                  <tr>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Common Solution</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>Conductive</td>
                    <td>Blockage or damage in outer/middle ear</td>
                    <td>Bone conduction hearing aids</td>
                  </tr>
                  <tr>
                    <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>Sensorineural</td>
                    <td>Damage to inner ear or nerves</td>
                    <td>Digital hearing aids, BTE or CIC</td>
                  </tr>
                  <tr>
                    <td><i className="fa-solid fa-ear-listen font-icon me-2"></i>Mixed</td>
                    <td>Combination of both</td>
                    <td>Personalized device + care</td>
                  </tr>

                </tbody>
              </table>
            </div>
            <div className="text-center mt-3">
              <a onClick={() => setIsFormOpen(true)} className="btn download-btn shadow fw-bold">
                <i className="fa-solid fa-calendar-plus me-2"></i> Book a Hearing aid Demo
              </a> {isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}
            </div>
          </div>
        </section>
      </div>
      {/* Hearing Aids Section */}
      <section className="container">
        <div className="text-center">
          <h2 className="fw-bold display-6 title">Hearing Aids: <span className="title-info">Your Gateway to Better Hearing</span></h2>
        </div>
        <p className="fs-5 mt-3">
          A hearing aid (or hearing machine) is a small electronic device worn in or behind the ear.
          It amplifies sounds to help you hear better.
        </p>
        <p className="fs-5 mt-3">
          At <strong>SFL Hearing Solutions</strong>, we help people identify the type and level of hearing loss and recommend the best hearing aid machine based on their specific needs.
        </p>


        <div className="row justify-content-md-center g-4">
          {/* BTE */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BTE} width="190" height="143" alt="hearing aids" fetchpriority="high"


                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">BTE (Behind the Ear)</h5>
                <p>
                  <i className="fa-solid fa-bolt  me-2 font-icon"></i>
                  <strong>Features:</strong> Powerful, Durable
                </p>
                <p>
                  <i className="fa-solid fa-children text-success me-2 "></i>
                  <strong>Ideal For:</strong> All Ages
                </p>
              </div>
            </div>
          </div>

          {/* CIC */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={CIC} width="190" height="143" alt="hearing aids" fetchpriority="high"


                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">CIC (Completely in Canal)</h5>
                <p>
                  <i className="fa-solid fa-eye-slash  me-2 font-icon"></i>
                  <strong>Features:</strong> Invisible, Discreet
                </p>
                <p>
                  <i className="fa-solid fa-briefcase text-success me-2"></i>
                  <strong>Ideal For:</strong> Working Professionals
                </p>
              </div>
            </div>
          </div>

          {/* Rechargeable */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={RechargeableHA} width="190" height="143" alt="hearing aids" fetchpriority="high"


                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">Rechargeable Aids</h5>
                <p>
                  <i className="fa-solid fa-battery-full  me-2 font-icon"></i>
                  <strong>Features:</strong> No battery hassle
                </p>
                <p>
                  <i className="fa-solid fa-user text-success me-2"></i>
                  <strong>Ideal For:</strong> Seniors
                </p>
              </div>
            </div>
          </div>

          {/* Bluetooth */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BluetootHA} width="190" height="143" alt="hearing aids"

                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">Bluetooth Hearing Aids</h5>
                <p>
                  <i className="fa-solid fa-mobile-screen-button me-2 font-icon"></i>
                  <strong>Features:</strong> App Control
                </p>
                <p>
                  <i className="fa-solid fa-user-gear text-success me-2"></i>
                  <strong>Ideal For:</strong> Tech-savvy Users
                </p>
              </div>
            </div>
          </div>
          <div className="box box-green">
            <h4 className="box-title">Choosing the Right Hearing Aid</h4>
            <ul className="list-unstyled feature-list">
              {[
                "Degree of hearing loss",
                "Lifestyle & daily routine",
                "Budget & comfort",
                "Brand preferences (Signia, Phonak, Starkey, Unitron, ReSound)",
              ].map((point, index) => (
                <li key={index}><i className="bi bi-check-circle-fill me-2"></i>{point}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="box box-white mt-4 p-3">
          <p className="fs-4">
            <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
            <strong>You search. We serve.</strong>
          </p>
          <h5 className="fw-semibold mb-2 fa-magnifying-glass">Common Search Queries:</h5>
          <p className="fst-italic text-dark mb-0">
            “small ear machine price”,  “best digital hearing aids”,  “hearing aid machine
            price”,  “ear voice machine price”,  “ear device for deaf”
          </p>
        </div>
        <div className="text-center mt-3">
          <a onClick={() => setIsFormOpen(true)} className="btn download-btn shadow fw-bold">
            <i className="fa-solid fa-calendar-plus me-2"></i> Book a Hearing aid trial
          </a> {isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}
        </div>
      </section>
      {/* What People Search */}

      {/* Clinic Locations */}
      <section className="container my-5">
        <h2 className="section-title">Visit the Nearest SFL Hearing Aid Centre</h2>
        <p>
          Just search for <span className="tag">ear hearing machine shop near me</span> or use the map below.
        </p>
        <div className="container">
          <div className="row align-items-center shadow rounded p-4">
            {/* Left side - Details */}
            <div className="col-md-8">
              <h3 className="location fw-bold">
                <i className="fa-solid fa-location-dot text-danger me-2"></i>Karnal
              </h3>
              <address className="mb-3 fs-5">
                SCO 401, Ground Floor, <br />
                Mughal Canal Road, Main Market,<br />
                Karnal, Haryana - 132001
              </address>
              <p className="fs-6">
                <i className="fa-solid fa-clock text-primary me-2"></i>
                <strong>Hours:</strong> Mon–Sat (10:00 AM - 07:00 PM)
              </p>
              <a
                href="https://goo.gl/maps/dC1fsAFuU6L1CHT19"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-custom-add btn-sm"
              >
                <i className="fa-solid fa-map-location-dot me-2"></i> Get Directions
              </a>
            </div>

            {/* Right side - Map or Image */}
            <div className="col-md-4 text-center">
<a href="https://goo.gl/maps/dC1fsAFuU6L1CHT19" target="_blank" rel="noopener noreferrer">
  <img
    src={maplocation}
    alt="karnal Hearing Aid Centre"
    fetchpriority="high"
    className="img-fluid rounded shadow-sm"
  />
</a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="container">
        <div className="container">
          <div className="cta-section text-center my-5">
            <p className="h4">
              <strong>
                <i className="fa-solid fa-volume-high me-2"></i> Visit SFL Hearing Solutions Today
              </strong>
            </p>
            <p className="h5">
              Fill the form or call us today to book a hearing test at your nearest hearing aids
              centre.
            </p>
            <a
              href="tel:+919015401540"
              className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold text-decoration-none"
            >
              <i className="fa-solid fa-phone me-2 mt-3"></i>Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Appointment Form */}
      <section className="enquiry-section py-5">
        <div className="container">
          <h4 className="form-title section-title fw-bold">Book a Hearing Test</h4>
          <div className="row align-items-center py-3 g-4">
            {/* Left Section */}
            <div className="col-lg-6 image-wrapper">
              <div className="image-box">
                <img src={Bookhearingtest} alt="Main" fetchpriority="high"
                  className="main-img" />
                <img src={RechargeableHA} alt="Secondary" fetchpriority="high"
                  className="secondary-img" />
              </div>
            </div>

            {/* Right Section */}
            <div className="col-lg-6">

              <ShortLeadForm />

            </div>
          </div>
        </div>
      </section>

      {/* Brands Section */}
        <section className="container my-5">
        <h4 className="section-title mb-4">Brands We Deal In:</h4>
        <div className="row g-4">
          {[
            {
              brand: "Signia",
              image: signiaImg,
              models: "Silk, Pure, Motion, Insio",
            },
            {
              brand: "Phonak",
              image: phonakImg,
              models: "Audeo, Virto, Naida, Paradise",
            },
            {
              brand: "ReSound",
              image: resoundImg,
              models: "Nexia, Omnia, Key, Enzo, Magna",
            },
          ].map((item, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="mb-3">
                  <img src={item.image} className="card-img-top" alt={`${item.brand} Hearing Aids`} />
                </div>
                <h5 className="card-title">{item.brand}</h5>
                <p className="card-text">{item.models}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <FAQ />
      {/* Testimonials Section */}
      <section className="container my-5">
        <h5 className="text-center mb-4">What Our Customers Say</h5>
        <div className="row g-4">
          {[
            {
              name: "Pankaj Thakur",
              review:
                "Sound for life is excellent... They have good trained audiologist... Thanx Dr. Mohana for your kind suggestion and treatment.",
              stars: 5,
            },
            {
              name: "Archana Singh",
              review:
                "I am very satisfied with the products and services... trust this clinic, this is really reliable.",
              stars: 4,
            },
            {
              name: "Praphul Fernandis",
              review:
                "The staff was attentive and knowledgeable... creating a comfortable environment... overall service left a lasting positive impression.",
              stars: 3.5,
            },
          ].map((t, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm border-0 p-4">
                <div className="mb-3">
                  <i className="fa-solid fa-quote-left text-primary fa-2x"></i>
                </div>
                <p className="card-text">“{t.review}”</p>
                <div className="d-flex align-items-center mt-3">
                  <div>
                    <h6 className="mb-0 fw-bold">{t.name}</h6>
                    <div className="text-warning">
                      {[...Array(Math.floor(t.stars))].map((_, i) => (
                        <i key={i} className="fa-solid fa-star"></i>
                      ))}
                      {t.stars % 1 !== 0 && <i className="fa-solid fa-star-half-stroke"></i>}
                      {[...Array(5 - Math.ceil(t.stars))].map((_, i) => (
                        <i key={i} className="fa-regular fa-star"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Testimonial */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <h4 className="text-center mb-3">
              <i className="fa-solid fa-video me-2 text-danger"></i>Watch What Our Patients Say
            </h4>
            <div className="ratio ratio-16x9 shadow-sm rounded">
              <div>
                <LiteYouTubeEmbed
                  id="D9tDd5JXNUA"
                  title="What’s new in Material Design for the web (Chrome Dev Summit 2019)"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Write Review Button */}
        <div className="text-center mt-5">
          <a href="https://g.page/r/CeeQggrGpUCvEAI/review" className="btn btn-custom btn-lg shadow">
            <i className="fa-solid fa-pen-to-square me-2"></i>Write Your Review
          </a>
        </div>
      </section>
      {/* Final CTA */}
      {/* CTA Section */}
      <section className="container my-5">
        <div className="bg-white border shadow rounded p-4">
          <div className="text-center mb-4">
            <h5 className="fw-bold">🎧 Ready to Buy a Hearing Aid?</h5>
          </div>
          <p className="fs-5 text-muted">
            Depending on your needs, preferences, and financial situation, we assist you in selecting the
            appropriate hearing aid for moderate loss, old age, or invisible choices.
          </p>

          <p className="fs-5 text-muted">Explore the latest models from <strong>ReSound, Phonak, Signia,</strong> and other companies.</p>
          <div className="mb-4">
            <h5 className="mb-3">
              <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
              <strong>Top Searches Our Users Look For:</strong>
            </h5>
            <div className="d-flex flex-wrap gap-2">
              {[
                "Digital hearing machine price",
                "Best hearing aid in Karnal",
                "Signia Silk X price",
                "Phonak hearing aid cost",
                "Ear machine price in Karnal"
              ].map((item, index) => (
                <span
                  key={index}
                  className="badge bg-light text-dark border px-3 py-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <i className="fa-solid fa-tags me-1 text-primary"></i> {item}
                </span>
              ))}
            </div>
          </div>

          <div className="sfl-highlight-box text-center mt-4 p-4 rounded">
            <h5 className="sfl-highlight-heading fw-semibold">
              Sound For Life – Helping Karnal Hear Better, Every Day
            </h5>
            <p className="sfl-highlight-subtext mt-2">
              Let us help you hear clearly again with the right device near you.
            </p>
          </div>
        </div>
      </section>
      <section className="container my-5">
        <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #006ea1, #006ea1)', color: '#fff' }}>
          <div className="container text-center">
            <h5 className="fw-bold mb-3">
              <i className="fa-solid fa-calendar-check me-2"></i>
              Let’s Help You Hear Again – Contact Us Now!
            </h5>
            <p className="fs-5 mb-4">
              Your search for <strong>hearing loss machine</strong>, <strong>hearing aid in Karnal </strong>and <strong>ear
                machine price in Karnal </strong> ends here.

            </p>

            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
              <a
                href="tel:+919015401540"
                className="btn btn-warning btn-lg fw-bold px-4 shadow"
              >
                <i className="fa-solid fa-phone me-2"></i> Contact Us
              </a>

              <a
                href="https://wa.me/919015706707"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-light btn-lg fw-bold px-4 text-dark shadow"
              >
                <i className="fa-brands fa-whatsapp me-2"></i> WhatsApp Chat
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

    </>
  );
};

export default InfoKarnal;